export default "/images/9d4a1d0b258007b5c780f6acace16124.avif";